// I4: "Prescribed by … · check on …" in the rider's program window. On a protocol
// read through its assignment (calendar, current protocols of a horse) the API
// (Resources/Protocol.php) sends `prescribed_by: { first_name, last_name }`, null
// once that account is deleted, and `vet_check_at` ('YYYY-MM-DDT00:00:00' or
// null). The assignment's reason and diagnostic never travel there, and nothing
// here reads them. Pure, no '@/' import: tested with `node --test`.

const clean = (value) => (typeof value === 'string' ? value.trim() : '')

// "First Last", "First" or "Last"; null when nobody can be named.
export const prescriberName = (prescribedBy) => {
    if (!prescribedBy || typeof prescribedBy !== 'object') return null
    const name = [prescribedBy.first_name, prescribedBy.last_name].map(clean).filter(Boolean).join(' ')
    return name || null
}

// The vet check as the API sent it, or null when there is none to show.
export const vetCheckDate = (value) => {
    if (typeof value !== 'string' || !value.trim()) return null
    return Number.isFinite(new Date(value).getTime()) ? value : null
}

const capitalize = (text) => text.charAt(0).toLocaleUpperCase() + text.slice(1)

// The whole line, each half only when it is known, or null when neither is.
// `t` is vue-i18n's; `formatDate` turns vet_check_at into the app's date format.
export const prescriptionLine = (protocol, { t, formatDate }) => {
    const name = prescriberName(protocol?.prescribed_by)
    const checkAt = vetCheckDate(protocol?.vet_check_at)

    const parts = []
    if (name) parts.push(t('protocol.prescribed-by', { name }))
    if (checkAt) parts.push(t('protocol.vet-check-on', { date: formatDate(checkAt) }))

    // "check on …" opens the line when nobody is named.
    return parts.length ? capitalize(parts.join(' · ')) : null
}
